import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { ApplicationMainPageInitialData } from '../../shared/models/custom-types';
import { DokumentApi } from '../../shared/services/api/dokument.api';

export const applicationMainPageResolver: ResolveFn<
  ApplicationMainPageInitialData
> = (
  route: ActivatedRouteSnapshot,
): Observable<ApplicationMainPageInitialData> => {
  const dokumentApi = inject(DokumentApi);
  return dokumentApi.getMainPageDokumentsList$();
};
